import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Density = 'comfortable' | 'compact';

interface PreferencesState {
  density: Density;
  sidebarExpanded: boolean;
  conversationView: boolean;
  setDensity: (d: Density) => void;
  setSidebarExpanded: (expanded: boolean) => void;
  toggleSidebar: () => void;
  setConversationView: (enabled: boolean) => void;
}

export const usePreferencesStore = create<PreferencesState>()(
  persist(
    (set) => ({
      density: 'comfortable',
      sidebarExpanded: false,
      conversationView: true,
      setDensity: (density) => {
        set({ density });
        applyDensity(density);
      },
      setSidebarExpanded: (sidebarExpanded) => set({ sidebarExpanded }),
      toggleSidebar: () => set((s) => ({ sidebarExpanded: !s.sidebarExpanded })),
      setConversationView: (conversationView) => set({ conversationView }),
    }),
    {
      name: 'prufe-preferences',
      onRehydrateStorage: () => (state) => {
        if (state) applyDensity(state.density);
      },
    },
  ),
);

function applyDensity(density: Density) {
  document.documentElement.setAttribute('data-density', density);
}
